import React, { useState, useEffect } from "react";
import { Input, Button, message, Modal, Space } from "antd";
import { useNavigate } from "react-router-dom"; // 引入Link和useNavigate 3
import axiosInstance from "@/axios/axiosInstance";
import "./index.scss";
const Account = ({ userData, fetchUserInfo }) => {
  //邮箱
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  //密码
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [oldPasswordError, setOldPasswordError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false); //注销账号

  const [isHuanB, setIsHuanB] = useState(false); //换绑手机
  const [phoneCode, setPhoneCode] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const navigate = useNavigate(); // 获取 navigate 函数

  //邮箱
  const handleInputChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsValid(validateEmail(value));
  };

  const validateEmail = (email) => {
    // 使用正则表达式验证邮箱格式
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = () => {
    if (isValid) {
      // 邮箱格式正确，执行提交操作
      const formData = new FormData();
      formData.append("userId", userData.userId);
      formData.append("email", email);
      formData.append("deleteFlag", "0");

      try {
        axiosInstance
          .post("/account/update", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.data.code == "10000") {
              fetchUserInfo();
              message.success("修改成功");
              setEmail("");
            }
          })
          .catch((error) => {
            // 处理错误情况
            console.error("Error fetching user info:", error);
          });
      } catch (error) {
        // 处理错误情况
        console.error("Error fetching user info:", error);
      }
    } else {
      // 邮箱格式不正确，提示用户
      message.error("请输入有效的邮箱地址！");
    }
  };
  //密码
  const validatePassword = (password) => {
    // 校验密码长度是否为6-16位，且不能包含汉字
    const isValidLength = password.length >= 6 && password.length <= 16;
    const noChinese = !/[\u4e00-\u9fa5]/.test(password);
    return isValidLength && noChinese;
  };

  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);
    setPasswordError(""); // 清除密码错误提示

    // 校验密码格式
    if (!validatePassword(password)) {
      setPasswordError("密码应为6-16位，且不能包含汉字");
    }
  };
  const handleOldPasswordChange = (e) => {
    const password = e.target.value;
    setOldPassword(password);
    setOldPasswordError(""); // 清除密码错误提示

    // 校验密码格式
    if (!validatePassword(password)) {
      setOldPasswordError("密码应为6-16位，且不能包含汉字");
    }
  };
  const handleConfirmPasswordChange = (e) => {
    const password = e.target.value;
    setConfirmPassword(password);
    setConfirmError(""); // 清除确认密码错误提示

    // 校验确认密码与新密码是否一致
    if (password !== newPassword) {
      setConfirmError("新密码与确认密码不一致");
    }
  };

  const handleSubmitPas = () => {
    // 在提交之前进行最终校验
    if (!validatePassword(newPassword)) {
      setPasswordError("密码应为6-16位，且不能包含汉字");
      return;
    }

    if (newPassword !== confirmPassword) {
      setConfirmError("新密码与确认密码不一致");
      return;
    }

    // 如果校验通过，执行提交逻辑
    // ...
    // 邮箱格式正确，执行提交操作
    const formData = new FormData();
    formData.append("userId", userData.userId);
    formData.append("oldPassword", oldPassword);
    formData.append("password", newPassword);
    formData.append("deleteFlag", "0");

    try {
      axiosInstance
        .post("/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            fetchUserInfo();
            message.success("修改成功");
            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const cancelAccount = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    const formData = new FormData();
    formData.append("userId", userData.userId);
    formData.append("deleteFlag", "1");
    try {
      axiosInstance
        .post("/account/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            setIsModalOpen(false);
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("token");
            navigate("");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getPhoneCode = async () => {
    try {
      setSendButtonDisabled(true); // 禁用按钮开始倒计时
      setCountdown(60);
      axiosInstance
        .get(`/account/sendVerifyCode?phone=${userData.phone}`)
        .then((response) => {
          if (response.data.code == "10000") {
          } else {
            message.error(response.data.msg);
          }
        })
        .catch((error) => {
          // setError(error);
        });
      // 这里可以调用后端API发送验证码
      // 使用setInterval实现倒计时
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown > 0) {
            return prevCountdown - 1;
          } else {
            clearInterval(interval);
            setSendButtonDisabled(false); // 倒计时结束，启用按钮
            return 0;
          }
        });
      }, 1000);
    } catch (error) {
      console.error("手机号验证失败", error);
    }
  };
  const setPhoneCodeChange = (e) => {
    const value = e.target.value;
    setPhoneCode(value);
  };
  const handleCancelHb = () => {
    setIsHuanB(false);
  };
  const handleOkHb = () => {};
  return (
    <div className="mespage">
      <h3 className="mespage_til">注册信息</h3>
      <div className="login_mes">
        <p className="login_mes_name">当前邮箱：</p>
        <p className="login_int">
          <Input
            placeholder="请输入邮箱"
            value={email}
            onChange={handleInputChange}
          />
          <Button type="primary" onClick={handleSubmit} disabled={!isValid}>
            输入邮箱
          </Button>
        </p>
      </div>
      <div className="login_mes">
        <p className="login_mes_name">注册时间：</p>
        <p className="login_int">{userData.createTime}</p>
      </div>
      <div className="login_mes">
        <p className="login_mes_name">注册手机：</p>
        <p className="login_int">
          {userData.phone}{" "}
          <Button type="primary" onClick={setIsHuanB}>
            换绑手机
          </Button>
        </p>
      </div>
      <h3 className="mespage_til">个人资料</h3>
      <div className="login_mes">
        <p className="login_mes_name">注册邮箱：</p>
        <p className="login_int">{userData.email}</p>
      </div>
      <div className="login_mes">
        <p className="login_mes_name">当前密码：</p>
        <p className="login_int">***********</p>
      </div>
      <div className="login_mes">
        <p className="login_mes_name">旧密码：</p>
        <p className="login_int">
          <Input.Password
            placeholder="请输入新密码"
            value={oldPassword}
            onChange={handleOldPasswordChange}
          />
        </p>
        {oldPasswordError && (
          <p className="error-message">{oldPasswordError}</p>
        )}
      </div>
      <div className="login_mes">
        <p className="login_mes_name">新密码：</p>
        <p className="login_int">
          <Input.Password
            placeholder="请输入新密码"
            value={newPassword}
            onChange={handleNewPasswordChange}
          />
        </p>
        {passwordError && <p className="error-message">{passwordError}</p>}
      </div>

      <div className="login_mes">
        <p className="login_mes_name">确认密码：</p>
        <p className="login_int">
          <Input.Password
            placeholder="请再次输入新密码"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
          />
          <Button
            type="primary"
            onClick={handleSubmitPas}
            disabled={
              !validatePassword(newPassword) || newPassword !== confirmPassword
            }
          >
            修改密码
          </Button>
        </p>
        {confirmError && (
          <p className="error-message config-mes">{confirmError}</p>
        )}
      </div>
      <h3 className="mespage_til">账号注销</h3>
      <div className="login_mes">
        <p className="login_mes_name">当前账号：</p>
        <p className="login_int">
          {userData.phone}{" "}
          <Button type="primary" onClick={cancelAccount}>
            注销账号
          </Button>
        </p>
      </div>
      <Modal
        title="账号注销"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            取消
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            确定
          </Button>,
        ]}
      >
        <p>
          您正在发起账号注销流程，账号注销后您将失去本平台
          所有权限，已发布的所有内容自动删除且无法恢复。您 确认后在进行操作
        </p>
      </Modal>
      <Modal
        title="验证手机"
        open={isHuanB}
        onOk={handleOkHb}
        onCancel={handleCancelHb}
        footer={[
          <Button key="submit" type="primary" onClick={handleOkHb}>
            下一步
          </Button>,
        ]}
      >
        <p>
          需通过手机 <a href="javascripr:;">{userData.phone}</a> 进行身份验证
        </p>
        <div className="huanBphone">
          <Space size={50}>
            <Input
              placeholder="请输入验证码"
              value={phoneCode}
              onChange={setPhoneCodeChange}
            />

            <Button
              onClick={getPhoneCode}
              disabled={sendButtonDisabled}
              className="yam"
            >
              {countdown === 0 ? "获取验证码" : `${countdown}s`}
            </Button>
          </Space>
        </div>
      </Modal>
    </div>
  );
};

export default Account;
